import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'
import { CaseDownloadCTAItem } from 'components/cases/common/CaseDownloadCTA'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: '売上約130%上昇 - グローバルECサイト構築で「真のDX」を実現',
  title1: '売上約130%上昇 - グローバルECサイト構築で「真のDX」を実現',
  introduction_text:
    '自動車部品を世界中に販売するグローバルECサイトを構築しました。このサイトは、自動車リサイクルを通じて地球規模の循環型社会を目指しているサービスです。弊社は既存業務をシステム化するだけでなく、業務自体を変える「真のDX」の実現をお客様と共に実施しました。',
  company: '会宝産業株式会社',
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'クラウドネイティブ',
  tag2src: '/cases/cloudnative/',
  industryTagText: '小売/流通/卸',
  industryTagSrc: '/cases/retail/',
  color: '#fff',
  background: 'linear-gradient(262.37deg, #EA5703 13.17%, #F6AB00 100.01%)',
  staff1: '常務取締役　櫻井茂宏さん',
  staff2: '海外事業部　鈴木大詩さん・朝倉真珠美さん',
  image: '/images/img/cases/kaiho/top.png',
  alt: '売上約130%上昇 - グローバルECサイト構築で「真のDX」を実現',
  imgClass: 'fv_img_adjust2',
}

// プロジェクト概要
export const overviewTitle = 'ビジネス理解から始まった本当の意味でのDXプロジェクト'
export const overviewItem: OverviewItems[] = [
  {
    text: '会宝産業株式会社は1969年に創業し、石川県金沢市から世界約90カ国とネットワークを結んで中古自動車部品の供給を行っているグローバル企業です。',
  },
  {
    text: '自動車リサイクルを通して地球規模の循環型社会を目指す同社が現在注力しているのは、自動車の中古部品を世界中に販売するための「グローバルECサイト」プロジェクト。しかし、ECサイトと一言で言っても、自動車部品には非常に高度な専門知識やノウハウが含まれており、一般的なECサイト構築システムを転用することができません。',
  },
  {
    text: '今回のプロジェクトは、単純に「既存業務をシステム化するECサイト」を作るのではなく、業務自体を変えてシステムも同時に変更する「本当の意味でのDX」。',
    nonMargin: true,
  },
  {
    text: 'Aitriaはそんな困難なプロジェクトにおけるパートナー企業としてお声がけいただき、2021年6月以降要件定義から開発、実装、運用に取り組んでいます。',
  },
  {
    text: '今回は会宝産業株式会社の常務取締役・櫻井茂宏さん、海外事業部・鈴木大詩さんと朝倉真珠美さんに、Aitriaのプロジェクトメンバーとともにお話を伺いました。',
    nonMargin: true,
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: '特殊な業界要件の理解と対応',
        text: '自動車リサイクルという複雑で専門的な業界であり、一般的なECサイトシステムでは対応が難しいため、特定の要件を満たすシステムが必要。',
      },
      {
        title: '柔軟性のあるシステムの開発',
        text: '市場や業務の変化に応じて迅速に対応できる、柔軟性を持ったシステムの開発が求められている。',
      },
      {
        title: '国際的なビジネス対応',
        text: ' 中古自動車部品を世界中に供給するためのグローバルECサイトの構築が必要であり、多言語対応や国際物流の管理が課題。',
      },
    ],
    solutions: [
      {
        title: '深い業界理解に基づくカスタマイズ',
        text: 'Aitriaは業界知識を活用して、クライアントのニーズを理解し、特定の業界要件を満たすカスタマイズを行うことでシステムを開発。',
      },
      {
        title: '動的なシステム設計と迅速な改修対応',
        text: '初期のシステム構築から改修を繰り返しながら、業務の変化に対応できる柔軟なシステムを提供。',
      },
      {
        title: 'グローバルECサイトの開発と運用',
        text: '国際的な販売をサポートするグローバルECサイトの開発を担当し、多言語対応や国際販売の管理機能を組み込むことでクライアントの国際ビジネスを支援。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: '業務改革を諦めていませんか？',
  description:
    '業界特有の業務を深くヒアリングして要件を言語化し、AI駆動の開発で既存業務を変えながらシステムを鍛え上げる「本当のDX」を一緒に実現します。まずは、現在の課題やお悩みをお聞かせください。',
}

// 資料ダウンロード CTA
export const caseDownloadCTAItem: CaseDownloadCTAItem = {
  title: 'アプリ開発RFP作成のポイント',
  description: 'アプリ開発担当者向けに、失敗しないためのポイントをテンプレート付の1冊にまとめました',
  imageSrc: '/images/img/cases/cta_rfp.webp',
  href: '/download/rfp/',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
